export class StagingAccountConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "cloudAccountId",
            "baseName": "cloudAccountId",
            "type": "string",
            "format": "uuid"
        }
    ];
    static getAttributeTypeMap() {
        return StagingAccountConfig.attributeTypeMap;
    }
    constructor() {
    }
}
